import { render, staticRenderFns } from "./ShoppingCartButton.vue?vue&type=template&id=252d5c29&scoped=true&"
import script from "./ShoppingCartButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartButton.vue?vue&type=style&index=0&id=252d5c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d5c29",
  null
  
)

export default component.exports